(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupDialogController', ReportGroupDialogController);

    ReportGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReportGroup'];

    function ReportGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReportGroup) {
        var vm = this;

        vm.reportGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reportGroup.id !== null) {
                ReportGroup.update(vm.reportGroup, onSaveSuccess, onSaveError);
            } else {
                ReportGroup.save(vm.reportGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:reportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
